var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[(_vm.item)?[_c('div',{staticClass:"hash_tag_list"},_vm._l((_vm.item.tags),function(tag){return (tag.active)?_c('div',{staticClass:"hash_tag_list_item"},[_c('span',[_vm._v("#"+_vm._s(tag.title))])]):_vm._e()}),0)]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }